import { get, patch } from 'models/shared/helpers/axiosInstance';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import {
	Conversation,
	ConversationResponderEnum,
	ConversationsTableResponse,
	ListConversationsTableFilters,
} from '../interfaces/conversation.interface';

const baseConversationPath = '/v1/chatbot/conversations';

export const fetchActiveConversation = async (
	financialFormId: string,
): Promise<Conversation | null> => {
	try {
		const res = await get<Conversation[]>(
			buildPathWithQueryParams(baseConversationPath, {
				financialFormId,
				isActive: true,
			}),
		);
		return res.data[0] ?? null;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const updateConversationResponder = async (
	conversationId: string,
	responder: ConversationResponderEnum,
): Promise<Conversation> => {
	try {
		const res = await patch<Conversation>(
			`${baseConversationPath}/${conversationId}/responder`,
			{ responder },
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const updateInfobipAgentId = async (
	conversationId: string,
	infobipAgentId: string,
): Promise<Conversation> => {
	try {
		const res = await patch<Conversation>(
			`${baseConversationPath}/${conversationId}`,
			{ infobipAgentId },
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const fetchConversationsTable = async (
	filters: ListConversationsTableFilters,
): Promise<ConversationsTableResponse> => {
	try {
		const res = await get<ConversationsTableResponse>(
			buildPathWithQueryParams(`${baseConversationPath}/table`, {
				...filters,
			}),
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};
